
export default {
  getCoupList: { // 사용 가능한 쿠폰 내역 목록 조회
    method: 'POST',
    url: 'mrm/v1/permit/nrw/mySpace/coupon/getCoupList'
  },
  getUsedCoupList: { // 쿠폰 사용 내역 목록 조회
    method: 'POST',
    url: 'mrm/v1/permit/nrw/mySpace/coupon/getUsedCoupList'
  },
  registerCoupon: { // 쿠폰 등록
    method: 'POST',
    url: 'mrm/v1/permit/nrw/mySpace/coupon/registerCoupon'
  },
  saveCorsCoupon: { // 쿠폰대상 과정 저장
    method: 'POST',
    url: 'mrm/v1/permit/nrw/mySpace/coupon/saveCorsCoupon'
  }
}



// WEBPACK FOOTER //
// ./src/config/router/nrw/api/couponApi.js